import React, { useEffect, useState } from 'react';
import { TopBar } from './TopBar';
import { LeftNav } from './LeftNav';
import { Breadcrumb } from './Breadcrumb';
import { ChatBot } from '../chat/ChatBot';
interface AppShellProps {
  children: React.ReactNode;
  onLogout: () => void;
}
export function AppShell({
  children,
  onLogout
}: AppShellProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  useEffect(() => {
    const handleToggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };
    window.addEventListener('toggle-sidebar', handleToggleSidebar);
    return () => {
      window.removeEventListener('toggle-sidebar', handleToggleSidebar);
    };
  }, [isSidebarOpen]);
  return <div className="flex h-screen bg-neutral-50" data-id="element-585">
      {/* Left Navigation */}
      <LeftNav isOpen={isSidebarOpen} data-id="element-586" />
      {/* Main Content */}
      <div className="flex flex-1 flex-col overflow-hidden" data-id="element-587">
        {/* Top Bar */}
        <TopBar onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} onLogout={onLogout} isSidebarOpen={isSidebarOpen} data-id="element-588" />
        {/* Main Content Area */}
        <main className="flex-1 overflow-auto p-4" data-id="element-589">
          {/* Breadcrumb */}
          <Breadcrumb data-id="element-590" />
          {/* Page Content */}
          <div className="mt-3" data-id="element-591">{children}</div>
        </main>
      </div>
      {/* AI Chatbot */}
      <ChatBot data-id="element-592" />
    </div>;
}